import { render, staticRenderFns } from "./InputFieldComponent.vue?vue&type=template&id=5f122756&"
import script from "./InputFieldComponent.vue?vue&type=script&lang=js&"
export * from "./InputFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports